<template>
  <div class="component-container">
    <div class="password-login-box">
      <div class="tab-box">
        <div
          @click="onItemClick(0)"
          :class="active === 0 ? 'tab-item-select' : 'tab-item'"
        >
          账号密码登录
        </div>
        <div
          @click="onItemClick(1)"
          :class="active === 1 ? 'tab-item-select' : 'tab-item'"
        >
          验证码登录
        </div>
      </div>
      <div class="pwd-login-title">
        {{ active === 0 ? "密码登录" : "验证码登录" }}
      </div>
      <div class="account-box">
        <div class="account-img">
          <img class="image" src="@/assets/icon_account.png" />
        </div>
        <div class="account-input">
          <el-input
            :readonly="readonly"
            v-model="params.username"
            autocomplete="off"
            @click.native="handlerIptClick"
            :placeholder="active === 0 ? '请输入账号' : '请输入手机号'"
          />
        </div>
      </div>
      <div v-if="active === 0" class="account-box">
        <div class="account-img">
          <img class="image" src="@/assets/icon_password.png" />
        </div>
        <div class="account-input">
          <el-input
            :readonly="readonly"
            v-model="params.password"
            autocomplete="off"
            show-password
            @click.native="handlerIptClick"
            placeholder="请输入密码"
          />
        </div>
      </div>
      <div v-if="active === 1" class="account-box verification-code-box">
        <div class="account-img">
          <img class="image-code" src="@/assets/icon_verification_code.png" />
        </div>
        <div class="account-input-code">
          <el-input
            :readonly="readonly"
            v-model="params.securityCode"
            autocomplete="off"
            @click.native="handlerIptClick"
            placeholder="请输入验证码"
          />
        </div>
        <div class="get-code" @click="onGetCodeClick">
          {{ time >= 60 ? codeText : time + "s" }}
        </div>
      </div>
      <el-button :loading="loading" class="login-btn" @click="onLoginClick"
        >登 录</el-button
      >
      <div class="bottom-box">
        <div
          @click="onForgetPasswordClick"
          v-if="active === 0"
          class="forget-pwd"
        >
          忘记密码？
        </div>
        <div class="regiter-box">
          <span>没有易农账号？</span>
          <span class="regiter-now" @click="onRegiterClick">立即注册</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { setToken, cookieKeys, setCookieItem } from "@/utils/auth.js";
import {
  getAuthLogin,
  getSendLoginValidCode,
  getLoginByCode,
} from "@/api/login.js";
import AES from "@/utils/AES.js";
export default {
  name: "LoginAccount",
  data() {
    return {
      active: 0,
      params: {
        username: "",
        password: "",
        securityCode: "",
      },
      readonly: true,
      loading: false,
      time: 60,
      codeText: "获取验证码",
      timeinterval: undefined,
    };
  },
  beforeDestroy() {
    if (this.timeinterval) {
      clearInterval(this.timeinterval);
    }
  },
  methods: {
    handlerIptClick() {
      this.readonly = false;
    },
    onItemClick(index) {
      this.active = index;
    },
    //忘记密码
    onForgetPasswordClick() {
      this.$emit("onForgetPasswordClick");
    },
    //立即注册
    onRegiterClick() {
      this.$emit("onRegiterClick");
    },
    //获取验证码
    onGetCodeClick() {
      const { username } = this.params;
      if (!username) {
        this.$message.error("请输入手机号");
        return;
      }
      if (this.time < 60) return;
      this.time--;
      this.timeinterval = setInterval(() => {
        this.time--;
        if (this.time <= 0) {
          clearInterval(this.timeinterval);
          this.time = 60;
          this.codeText = "重新获取";
        }
      }, 1000);
      this._getSendLoginValidCode();
    },
    //登录
    onLoginClick() {
      const { username, password, securityCode } = this.params;
      if (!username) {
        this.$message.error("请输入账号");
        return;
      }
      if (this.active === 0) {
        if (!password) {
          this.$message.error("请输入密码");
          return;
        }
        this._getAuthLogin();
      } else {
        if (!securityCode) {
          this.$message.error("请输入验证码");
          return;
        }
        this._getLoginByCode();
      }
      this.readonly = true;
    },
    //账号密码登录
    _getAuthLogin() {
      const { password } = this.params;
      this.loading = true;
      getAuthLogin({
        ...this.params,
        password: AES.encrypt(password),
      })
        .then((res) => {
          const {
            data: { token, phone },
          } = res;
          this.loading = false;
          setToken(token);
          setCookieItem(cookieKeys.phone, phone);
          this.$router.replace("/");
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //发送登录验证码
    _getSendLoginValidCode() {
      const { username } = this.params;
      getSendLoginValidCode({ phone: username })
        .then((res) => {
          const { message } = res;
          this.$message.success(message || "发送成功");
        })
        .catch(() => {});
    },
    //验证码登录
    _getLoginByCode() {
      this.loading = true;
      getLoginByCode({ ...this.params })
        .then((res) => {
          const {
            data: { token, phone },
          } = res;
          this.loading = false;
          setToken(token);
          setCookieItem(cookieKeys.phone, phone);
          this.$router.replace("/");
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.component-container {
  padding: 35px 53px 33px 50px;
  .password-login-box {
    .tab-box {
      display: flex;
      .tab-item,
      .tab-item-select {
        margin-right: 19px;
        color: #333333;
        padding-bottom: 5px;
        font-size: 24px;
        cursor: pointer;
        border-bottom: 3px solid #fff;
      }
      .tab-item-select {
        color: #1082ff;
        font-size: 24px;
        font-weight: 700;
        border-bottom: 3px solid #1082ff;
      }
    }
    .pwd-login-title {
      padding-top: 35px;
      font-size: 18px;
      text-align: left;
      color: #333333;
    }
    .account-box {
      display: flex;
      align-items: center;
      margin-top: 28px;
      .account-img {
        .image {
          width: 30px;
        }
        .image-code {
          width: 40px;
          margin-left: -5px;
          margin-right: -5px;
        }
      }
      .account-input,
      .account-input-code {
        margin-left: 10px;
        .el-input {
          width: 360px;
        }
      }
      .account-input-code {
        .el-input {
          width: 240px;
        }
      }
      .get-code {
        width: 125px;
        height: 40px;
        margin-left: -5px;
        z-index: 2;
        line-height: 40px;
        background: #1082ff;
        border-radius: 0px 4px 4px 0px;
        font-size: 14px;
        cursor: pointer;
        color: #ffffff;
      }
    }
    .verification-code-box {
      margin-top: 25px;
    }
    .login-btn {
      width: 417px;
      height: 60px;
      margin-top: 60px;
      background-color: #1082ff;
      border-radius: 4px;
      color: #ffffff;
      font-size: 24px;
      cursor: pointer;
    }
    .bottom-box {
      display: flex;
      margin-top: 10px;
      justify-content: space-between;
      .forget-pwd {
        cursor: pointer;
        font-size: 14px;
        color: #333333;
      }
      .regiter-box {
        font-size: 14px;
        color: #333333;
        .regiter-now {
          cursor: pointer;
          color: #1082ff;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/login/components/loginaccount.vue